const state = {
    depositAmount: 0,
    transactionDetails: null
};
const getters = {
    depositAmount:state => state?.depositAmount,
     transactionDetails: state => state?.transactionDetails,
};
const actions = {
    setDepositAmount({ commit }, depositAmount) {
        commit('setDepositAmount', depositAmount);
    },
    setTransactionDetails({ commit }, transactionDetails) {
        commit('setTransactionDetails', transactionDetails);
    },
};
const mutations = {
    setDepositAmount(state, depositAmount){
        state.depositAmount =  depositAmount
    },
     setTransactionDetails(state, transactionDetails){
        state.transactionDetails = transactionDetails
    }
};
export default {
    state,
    getters,
    actions,
    mutations
};